import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'

import offerService from '../services/offerService'
import { queryClient } from '../utils/react-query'
import { Offer } from '../types/offers'

export function useOffer(id?: string) {
  const navigate = useNavigate()

  return useQuery(
    ['offer', id],
    async () => {
      const { earnableFrom, earnableTo, redeemableFrom, redeemableTo, places, categories, ...rest } =
        await offerService.getOne(id)

      const formattedEarnableFrom = earnableFrom ? new Date(earnableFrom).toISOString().split('T')[0] : ''
      const formattedEarnableTo = earnableTo ? new Date(earnableTo).toISOString().split('T')[0] : ''
      const formattedRedeemableFrom = redeemableFrom ? new Date(redeemableFrom).toISOString().split('T')[0] : ''
      const formattedRedeemableTo = redeemableTo ? new Date(redeemableTo).toISOString().split('T')[0] : ''

      const formattedPlaces = places.map(({ id }) => id)
      const formattedCategories = categories[0].id

      return {
        ...rest,
        earnableFrom: formattedEarnableFrom,
        earnableTo: formattedEarnableTo,
        redeemableFrom: formattedRedeemableFrom,
        redeemableTo: formattedRedeemableTo,
        places: formattedPlaces,
        categories: formattedCategories,
      }
    },
    {
      enabled: !!id,
      placeholderData: () => {
        const offers = queryClient.getQueryData<Offer[]>(['offers'])

        if (!offers) return undefined

        const offer = offers.find((offer) => offer.id === id)

        if (offer) {
          const { earnableFrom, earnableTo, redeemableFrom, redeemableTo, places, categories, ...rest } = offer

          const formattedEarnableFrom = earnableFrom ? new Date(earnableFrom).toISOString().split('T')[0] : ''
          const formattedEarnableTo = earnableTo ? new Date(earnableTo).toISOString().split('T')[0] : ''
          const formattedRedeemableFrom = redeemableFrom ? new Date(redeemableFrom).toISOString().split('T')[0] : ''
          const formattedRedeemableTo = redeemableTo ? new Date(redeemableTo).toISOString().split('T')[0] : ''
          const formattedPlaces = places.map(({ id }) => id)
          const formattedCategories = categories[0].id

          return {
            ...rest,
            earnableFrom: formattedEarnableFrom,
            earnableTo: formattedEarnableTo,
            redeemableFrom: formattedRedeemableFrom,
            redeemableTo: formattedRedeemableTo,
            places: formattedPlaces,
            categories: formattedCategories,
          }
        }
      },
      onError: () => {
        navigate('/rewards-and-offers')
      },
    }
  )
}
